/* eslint-disable @typescript-eslint/no-explicit-any */
export var eventTracker = function eventTracker(name) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: name
  });
};